import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IMarketYoyGrowthExpectation } from '../model/types'

/**
 * An offering starts expanded if any of its category records has
 * `isExpanded: true`.
 */
export const getInitialExpandedOfferings = (
  planningDetails: IMarketYoyGrowthExpectation[]
): ProgramTypes[] => {
  const expanded = new Set<ProgramTypes>()

  planningDetails.forEach((detail) => {
    if (detail.isExpanded) {
      expanded.add(detail.offering)
    }
  })

  return Array.from(expanded)
}
